import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { TopicSpecialist } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, dialogService: DialogService, domain: DomainDataService, app: AppService): GridSetup<TopicSpecialist> {

	return {
		rowName: { singular: 'Approved Specialist By Topic', plural: 'Approved Specialists  By Topic' },
		getRowKey: row => '' + row.topicId + '_' + row.volunteerId,
		stateKey: 'approved-specialist-by-topic-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, domain, service, app),
		renderRowClasses: row => row.isTopicEnabled ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
	}
}
